import Button from "react-bootstrap/Button";
import * as React from "react";
import "./routes.css";
import Gift from "../img/gift.jpg";
import GreenReactiveTriadsLogo from "../img/greenReactiveTriadsBodyworkLogo.png";
import AnnMovement from "../img/annMovement.jpg";
import ReactiveTriadsDvD from "../img/reactiveTriadsDvd.jpg";
import GiftCertificate from "../PaypalButtons/giftCertificate";

const aboutUsTitles = {
  color: "#B46000",
  padding: ".5rem",
  marginLeft: "1rem",
  paddingTop: "1rem",
};

const aboutBackground = {
  backgroundColor: "#D0C88E",
};
const aboutContentBackground = {
  backgroundColor: "#E9E4D2",
};
const aboutText = {
  padding: ".5rem",
  marginLeft: "1rem",
};
const contactAnn = {
  // height: "35vh",
  width: "10vw",
  borderRadius: "5px",
  boxShadow: "5px 5px 8px 5px rgba(0, 0, 0, 0.449)",
  marginLeft: "1rem",
};

function Store() {
  return (
    <>
      <div style={aboutBackground}>
        <div className="container">
          <div style={aboutContentBackground}>
            <h1 style={aboutUsTitles}>Store</h1>
            <div style={aboutText}>
              <h5>
                <strong>How to purchase from our store</strong> <br />
              </h5>
              <p>
                You may call us, write us, or email us or use our Secure Online
                PayPal Store set up. Please do not put your credit card
                information in any emails to us since that is not a secure
                method to send that information. Make sure to give us your phone
                number and we'll call you to process your order.
              </p>
            </div>
            <div style={aboutText}>
              <h5>
                <strong>Gift Certificate</strong>
              </h5>
              <a href="/about" target="_blank" rel="noreferrer">
                Ann Watkins, MA, Licensed Massage Therapist #000393 or Staff
              </a>
              <br />
              {/* Will link to checkout and have a hover */}
              {/* <a href=""> */}
              <div className="p-2">
                <img src={Gift} style={contactAnn} alt="Gift" />
              </div>
              {/* </a> */}
              <br />
              <p>
                Our massage therapy is unlike any massage you've ever had. We
                work together with a special technique to create muscle balance
                and tissue health, relieving and correcting the underlying
                problems associated with most chronic pain. Our clients usually
                begin to get relief right away and by the third session it’s
                clear what the solution to your problem is. Though relief does
                not always require continued maintenance, many of our clients
                still return to achieve enhanced relaxation as well as physical
                and emotional well being.
              </p>
              <p>
                Print out the PayPal receipt and use that as the gift
                certificate confirmation until you receive the Gift Certificate
                in the mail. In a rush? Call us 1-860-599-4533!
              </p>
              <a
                href="https://www.paypal.com/ncp/payment/ACKSY7R7CT45Y"
                target="_blank"
                rel="noreferrer"
              >
                <small>Paypal Gift Certificate - see details ››</small>
              </a>
              <p>
                <strong>
                  $110.00 for 1 hour and $25.00 for every 15 minutes after that.
                </strong>
              </p>
              <GiftCertificate />
            </div>

            <div
              style={aboutText}
              // id="reactivetriadsdvd"
            >
              <h5>
                <strong>Reactive Triads™</strong>
              </h5>
              {/* Will link to checkout and have a hover */}
              {/* <a href=""> */}
              <div className="p-2">
                <img
                  src={GreenReactiveTriadsLogo}
                  style={contactAnn}
                  alt="GreenReactiveTriadsLogo"
                />
              </div>
              {/* </a> */}
              <br />
              <p>
                Reactive Triads™ are three elements activated in the body that
                cause a muscle to switch off resulting in muscle pain, nerve
                pain, limited range of motion. Integrating lymphatic drainage
                and jolts, Reactive Triads™ are exceptionally effective in
                solving chronic pain problems due to muscle imbalance caused by
                injury, whiplash, repetitive motion and stress.
              </p>
              <p>
                This DVD set documents Ann Watkins’ original work Reactive
                Triads™: a breakthrough in chronic pain relief published 2006.
                Great for neuronerds.
              </p>
              <div className="p-2">
                <img
                  src={ReactiveTriadsDvD}
                  style={contactAnn}
                  alt="ReactiveTriadsDvD"
                />
              </div>
              <a href="/classes" target="_blank" rel="noreferrer">
                <small>Reactive Triads Classes - see details ››</small>
              </a>
              <br />
              <a href="/classes" target="_blank" rel="noreferrer">
                <small>To Purchase Reactive Triads ››</small>
              </a>
              <br />
            </div>

            <div style={aboutText}>
              <h5>
                <strong>Supervision and Mentoring</strong> <br />{" "}
              </h5>
              {/* Will link to checkout and have a hover */}
              {/* <a href=""> */}
              {/* <img
                  src={GreenReactiveTriadsLogo}
                  style={contactAnn}
                  alt="Gift"
                /> */}
              {/* </a> */}
              <br />
              <p>
                I am available to help you build greater confidence and a more
                effective practice through supervision and mentoring. This can
                happen in person, over the phone or over video conferencing
                (Zoom). Prepare your questions before each call and I will
                provide you with helpful guidance. I’ve had a thriving practice
                since 1988 and can answer questions on how to build a practice
                from the ground up with guidance on how to more effectively
                treat your clients. This is especially useful if you have taken
                courses with me and are applying the work in sessions with your
                clients.
              </p>
              <p>
                In person supervision and mentoring are also available.
                Interested in an internship to practice your skills while still
                in massage school? This is a perfect place for that.{" "}
              </p>
              <p>
                <strong>Phone Mentoring: </strong>Free consultation
                <br />
                $40.00 per 1/2 hour
              </p>
              <p>
                Phone{" "}
                <a href="tel:860-599-4533" target="_blank" rel="noreferrer">
                  <small>860-599-4533</small>
                </a>{" "}
                <br />
                E-mail
                <a
                  href="mailto:bodymindspiritanatomy@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <small> bodymindspiritanatomy@gmail.com </small>
                </a>
              </p>

              <div>
                <p>
                  <strong>Check out my DVD Reactive Triads™: </strong>
                  <br />A Breakthrough in Chronic Pain Relief, published in 2006
                  – solving chronic muscle pain problems and achyness that used
                  to have no remedy. This DVD documents my original body work
                  that involves the muscle system, the lymphatic system and the
                  joint system. For more information, click below:{" "}
                  <a
                    href="https://www.bodymindspiritanatomy.com/offers/tEMaQJqu"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button>Go to Offers</Button>
                  </a>
                </p>
              </div>

              {/* Old Paypal Btn */}
              {/* <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="ARAQGR837G28A">
<table>
<tr><td><input type="hidden" name="on0" value="Select">Select</td></tr><tr><td><select name="os0">
	<option value="One half hour">One half hour $40.00 USD</option>
	<option value="One hour">One hour $75.00 USD</option>
</select> </td></tr>
</table>
<input type="hidden" name="currency_code" value="USD">
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_cart_SM.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form> */}
              {/* Old Paypal Btn */}
            </div>

            <div style={aboutText}>
              <h5>
                <strong>Conscious Anatomy™</strong> <br />{" "}
              </h5>
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                To Conscious Anatomy™ site click here. ››
              </a>
              <br />
              {/* Will link to checkout and have a hover */}
              {/* <a href=""> */}
              <div className="p-2">
                <img src={AnnMovement} style={contactAnn} alt="AnnMovement" />
              </div>

              {/* </a> */}
              <br />
              <p>
                Embark on becoming a sponge for anatomy terms and concepts with
                blended, on-line available, interactive, blissful movement flow
                trainings in Conscious Anatomy™ offering tools specific to
                your-self care needs.
              </p>
              <p>
                Enhance the health of your body and inner calm through Conscious
                Anatomy™ Trainings. Drop the drudgery of crunched posture form
                studying anatomy from books and discover ease of learning
                anatomy through blissful, flowing, movement, right down to your
                fingertips.
              </p>
              <p>
                From the comforts of your own home, get more fit and enjoy
                Conscious Anatomy™ on-line audio classes, supplemented with
                video, coupled with live conference call Q & A sessions.
              </p>
              <a href="/classes" target="_blank" rel="noreferrer">
                <small>Conscious Anatomy™ Classes - see details ››</small>
              </a>
              <br />
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <small>
                  To Conscious Anatomy™ site click here for free sample class
                  access. ››
                </small>
              </a>
              <br />
            </div>

            {/* Old View Cart Btn */}
            {/* <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="encrypted" value="-----BEGIN PKCS7-----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-----END PKCS7-----
">
<input type="image" src="https://www.paypal.com/en_US/i/btn/btn_viewcart_SM.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form> */}
            {/* Old View Cart Btn */}
          </div>
        </div>
      </div>
    </>
  );
}
export default Store;
